import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "prices" }
const _hoisted_3 = { class: "price-item" }
const _hoisted_4 = { class: "price-title" }
const _hoisted_5 = { class: "price-value" }
const _hoisted_6 = { class: "price-item" }
const _hoisted_7 = { class: "price-title" }
const _hoisted_8 = { class: "price-value" }
const _hoisted_9 = { class: "price-item" }
const _hoisted_10 = { class: "price-title" }
const _hoisted_11 = { class: "price-value" }
const _hoisted_12 = {
  key: 0,
  class: "extra-fee"
}
const _hoisted_13 = {
  key: 1,
  class: "extra-fee"
}
const _hoisted_14 = {
  key: 2,
  class: "prepay-amount"
}
const _hoisted_15 = { class: "price-title" }
const _hoisted_16 = { class: "price-value" }
const _hoisted_17 = { class: "additional-text" }
const _hoisted_18 = {
  key: 3,
  class: "additional-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Card"], null, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("landingPage.chargingPricesCard.title")), 1),
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("landingPage.chargingPricesCard.dcChargerTitle")), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString($setup.formatPrice($props.dcChargerPrice)) + " " + _toDisplayString($setup.currencyLabel) + " / " + _toDisplayString($setup.translatePricingUnit($props.dcChargerBaseOfCalculation)), 1)
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("landingPage.chargingPricesCard.rapidChargerTitle")), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString($setup.formatPrice($props.rapidChargerPrice)) + " " + _toDisplayString($setup.currencyLabel) + " / " + _toDisplayString($setup.translatePricingUnit($props.rapidChargerBaseOfCalculation)), 1)
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("landingPage.chargingPricesCard.acChargerTitle")), 1),
          _createElementVNode("span", _hoisted_11, _toDisplayString($setup.formatPrice($props.acChargerPrice)) + " " + _toDisplayString($setup.currencyLabel) + " / " + _toDisplayString($setup.translatePricingUnit($props.acChargerBaseOfCalculation)), 1)
        ])
      ]),
      ($props.guestCommission > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[0] || (_cache[0] = _createTextVNode(" + ", -1)),
            _createElementVNode("strong", null, _toDisplayString($setup.formatPrice($props.guestCommission)) + " " + _toDisplayString($setup.currencyLabel), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("landingPage.chargingPricesCard.guestCommission")), 1)
          ]))
        : (!$props.hideRegistrationCharge && $props.registrationCharge > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _cache[1] || (_cache[1] = _createTextVNode(" + ", -1)),
              _createElementVNode("strong", null, _toDisplayString($setup.formatPrice($props.registrationCharge)) + " " + _toDisplayString($setup.currencyLabel), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("landingPage.chargingPricesCard.registrationCharge")), 1)
            ]))
          : _createCommentVNode("", true),
      (typeof $props.prepayAmount === 'number')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("landingPage.chargingPricesCard.prepayAmountTitle")), 1),
            _createElementVNode("span", _hoisted_16, _toDisplayString($setup.formatPrice($props.prepayAmount)) + " " + _toDisplayString($setup.currencyLabel) + " / " + _toDisplayString(_ctx.$t("landingPage.chargingPricesCard.occasion")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("landingPage.chargingPricesCard.pricesValidFrom", {
          date: $setup.format.formatDate($props.validFrom)
        })), 1),
      (
        (!$props.guestCommission || $props.guestCommission === 0) &&
        !$props.hideRegistrationCharge &&
        $props.registrationCharge > 0
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t("landingPage.chargingPricesCard.registrationChargeAdditionalText")), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}